module.exports = {
    MASTERCARD: 'mastercard',
    VISA: 'visa',
    MAESTRO: 'maestro',
    AMEX: 'american express',
	CHINA: 'china unionpay',
    BLANCHE: 'diners clubcarte blanche',
    INTERNATIONAL: 'diners club international',
    USCANADA: 'diners club us & canada',
    DISCOVER: 'discover card',
    JCB: 'jcb',
    LASER: 'laser',
    DANKORT: 'dankort',
    VISAELEC: 'visa electron'
};
